import { get, omit } from 'lodash';

export const isActiveFieldLoading = (state) => {
  return (
    // TODO: Move the list of field loading props to a constants
    // and use it both here and in duck
    get(state, 'preload.boundary') !== 'fetched'
    || get(state, 'preload.features') !== 'fetched'
  );
};

const noneAreUnloaded = (preload) => {
  return !Object.values(preload).some((value) => {
    return value === 'unloaded';
  });
};

export const isFullPayloadInitialLoadDone = (state) => {
  return noneAreUnloaded(state.preload || {});
};

export const isInitialLoadDone = (state) => {
  return noneAreUnloaded(omit(state.preload || {}, [
    'scripts',
    'year',
    'zones',
    'allFieldsFeatures'
  ]));
};

export const isManageScriptListLoadDone = (state) => {
  return get(state, 'preload.scripts') === 'fetched';
};
